import { frontendURL } from '../../../helper/URLHelper';
import InternalChatPage from './InternalChatPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat_index',
    component: InternalChatPage,
    meta: {
      featureFlag: FEATURE_FLAGS.INTERNAL_CHAT,
      permissions: ['administrator', 'internal_chat_access'],
    },
  },
];

export default routes;
